import { IProps } from '@/Interfaces/Icons/Props.interface';

const ClearIcon = (props: IProps) => {
  return (
    <svg width='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M3.64163 2.95509C4.81029 1.9446 6.33372 1.33334 7.99992 1.33334C11.6818 1.33334 14.6666 4.31811 14.6666 8.00001C14.6666 9.42408 14.2201 10.7439 13.4594 11.8271L11.3333 8.00001H13.3333C13.3333 5.05449 10.9455 2.66668 7.99992 2.66668C6.56647 2.66668 5.2651 3.23219 4.30674 4.15229L3.64163 2.95509ZM12.3582 13.0449C11.1895 14.0554 9.66612 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8.00001C1.33325 6.57592 1.77978 5.25612 2.54045 4.17297L4.66659 8.00001H2.66659C2.66659 10.9455 5.0544 13.3333 7.99992 13.3333C9.43339 13.3333 10.7347 12.7678 11.6931 11.8477L12.3582 13.0449Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default ClearIcon;
